import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { Tray } from './tray';
import { CartStatus } from 'projects/cart-tv/src/app/data/cart-status';

@JsonObject('model.Cart')
export class Cart extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Number, 'number')
  number: number;

  @JsonProperty(ShortProject, 'project')
  project: ShortProject;

  @JsonProperty(CartStatus, 'status')
  status: CartStatus;

  @JsonProperty([Tray], 'trays')
  trays: Tray[];

  @JsonProperty(Number, 'totalQty')
  totalQty?: number;

  @JsonProperty(Number, 'filledQty')
  filledQty?: number;
}
